import { VehicleModel } from '../../vehicle/models/vehicle.model';
import {CustomerModel} from '../../titleregistration/models/customer.model';

export class InsuranceSearchResultModel {

    // Insurance Policy
    id: number;
    insurancePolicyNumber: string;
    effectiveDate: Date;
    endDate: Date;
    insurancePolicySourceTypeId: number;
    receivedDate: Date;
    // Insurance Policy Company
    insuranceCompanyId: number;
    insuranceCompanyName: string;
    adotCode: string;
    naicCode: string;
    createdDate: Date;
    notifyDate: Date;

    // Insurance Policy Type
    insurancePolicyTypeId: number;
    insurancePolicyTypeDisplayValue: string;

    // Vehicle Information
    insurancePolicyVehicleId: number;
    vehicleId: number;
    vehicle: VehicleModel;
    insurancePolicyVehicleCreatedDate: Date;

    // Customer Information
    insurancePolicyHolderId: number;
    customerNumberId: number;
    customer: CustomerModel;
    insurancePolicyHolderCreatedDate: Date;

}
